

<nav class="bg-white fixed w-full z-20 top-0 start-0 border-b border-gray-200">
    <div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-2 lg:p-4">
        <a routerLink="/"
        class="inline-flex items-center text-xl font-semibold text-gray-900">
        <img src="assets/images/logo.svg" class="w-[160px] md:[w-180px] " alt="logo">
      </a>
      <div class="flex md:order-2  space-x-3 md:space-x-0 rtl:space-x-reverse gap-3">
          <button *ngIf="!authenticatUser" type="button" (click)="navigateTo('auth/login')" class="hidden md:block text-white bg-primary-500 hover:bg-primary-600 hover:text-white font-medium rounded-lg text-sm px-4 py-2 text-center">Login</button>
          <button *ngIf="!authenticatUser" type="button" (click)="navigateTo('auth/register')" class="hidden md:block text-gray-900 bg-gray-300 hover:bg-primary-500 hover:text-white font-medium rounded-lg text-sm px-4 py-2 text-center">Sign Up
          </button>

          <button *ngIf="authenticatUser" type="button" (click)="navigateTo('/dashboard')" class="hidden md:block text-white bg-primary-500 hover:bg-primary-600  font-medium rounded-lg text-sm px-4 py-2 text-center">Dashboard
          </button>
          <button data-collapse-toggle="navbar-sticky" type="button" class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200" aria-controls="navbar-sticky" aria-expanded="false">
            <span class="sr-only">Open main menu</span>
            <svg class="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 14">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 1h15M1 7h15M1 13h15"/>
            </svg>
        </button>
      </div>
    <div class="items-center justify-between hidden w-full md:flex md:w-auto md:order-1" id="navbar-sticky">
      <ul class="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white">
        <li>
          <a class="block py-2 px-3  text-primary-500 rounded md:bg-transparent  md:p-0" aria-current="page" routerLink="/">Home</a>
        </li>
        <li>
          <a class="block py-2 px-3 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0">About</a>
        </li>
        <li>
          <a class="block py-2 px-3 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0">Services</a>
        </li>
        <li>
          <a class="block py-2 px-3 text-gray-700 rounded hover:bg-gray-100 md:hover:bg-transparent md:hover:text-primary-500 md:p-0">Contact</a>
        </li>
        <div class="flex gap-3 flex-wrap">
          <button *ngIf="!authenticatUser" type="button" (click)="navigateTo('auth/login')" class="block md:hidden text-white bg-primary-500 hover:bg-primary-600 hover:text-white font-medium rounded-lg text-sm px-4 py-2 text-center">Login</button>
          <button *ngIf="!authenticatUser" type="button" (click)="navigateTo('auth/register')" class="block  md:hidden text-gray-900 bg-gray-300 hover:bg-primary-500 hover:text-white font-medium rounded-lg text-sm px-4 py-2 text-center">Sign Up
          </button>
          <button *ngIf="authenticatUser" type="button" (click)="navigateTo('/dashboard')" class="block md:hidden text-white bg-primary-500 hover:bg-primary-600  font-medium rounded-lg text-sm px-4 py-2 text-center">Dashboard
          </button>
        </div>
      </ul>
    </div>
    </div>
  </nav>
  